module.exports = __webpack_public_path__ + "img/jester_ui_category_icons.4f34941b.png";